/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// CD Sanket


if(document.querySelectorAll('#js_checkout[name="checkouts"]').length){
  document.querySelector('#js_checkout[name="checkouts"]').addEventListener("click", function(e) {
    
      e.preventDefault();
    
      var po_number = document.getElementById("p_o_id").value;
      var attributes = "";
  
      if (po_number != undefined) {
        
          var xhr = new XMLHttpRequest();
          xhr.open("POST", '/cart/update.js', true);
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.onreadystatechange = function() {
              if (xhr.readyState === 4 && xhr.status === 200) {
                var json = JSON.parse(xhr.responseText);
                console.log(json)
                document.querySelector('#CartPageForm').submit();
                window.location.href = "/checkout";
              }
          };
          var data = JSON.stringify({
              "attributes": {
                'Purchase Order No.': po_number
              }
          });
          xhr.send(data);
      }
  });
}

// CD Arshit
if(document.querySelector('.collection__dynamic-part') && document.querySelector('.collection_page_change[collection_title]')){
  var old_html = document.querySelector('.collection__dynamic-part').innerHTML,
      coll_title = document.querySelector('.collection_page_change').getAttribute('collection_title');
  if(coll_title == 'all'){
    coll_title = 'all';
  }
  document.querySelector('.collection__dynamic-part').innerHTML = document.querySelector('.collection__dynamic-part').innerHTML = `<div class="collection_header card__header w3_bg"><h1 class="collection__title heading h1">`+ coll_title +`</h1></div>` + old_html;
}


